import React, { useState, ReactNode } from "react";

interface TooltipProps {
  children: ReactNode;
  content: ReactNode;
  position?: "top" | "bottom" | "left" | "right";
  delay?: number;
}

const Tooltip: React.FC<TooltipProps> = ({
  children,
  content,
  position = "top",
  delay = 300,
}) => {
  const [active, setActive] = useState(false);
let timeout: NodeJS.Timeout | number;


  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, delay);
  };

  const hideTip = () => {
    clearTimeout(timeout);
    setActive(false);
  };

  // Position classes
  const getPositionClasses = () => {
    switch (position) {
      case "top":
        return "bottom-full left-1/2 transform -translate-x-1/2 mb-2";
      case "bottom":
        return "top-full left-1/2 transform -translate-x-1/2 mt-2";
      case "left":
        return "right-full top-1/2 transform -translate-y-1/2 mr-2";
      case "right":
        return "left-full top-1/2 transform -translate-y-1/2 ml-2";
      default:
        return "bottom-full left-1/2 transform -translate-x-1/2 mb-2";
    }
  };

  // Arrow classes
  const getArrowClasses = () => {
    switch (position) {
      case "top":
        return "bottom-[-4px] left-1/2 transform -translate-x-1/2 border-t-black";
      case "bottom":
        return "top-[-4px] left-1/2 transform -translate-x-1/2 border-b-black";
      case "left":
        return "right-[-4px] top-1/2 transform -translate-y-1/2 border-l-black";
      case "right":
        return "left-[-4px] top-1/2 transform -translate-y-1/2 border-r-black";
      default:
        return "bottom-[-4px] left-1/2 transform -translate-x-1/2 border-t-black";
    }
  };

  return (
    <div
      className="relative inline-block"
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {children}
      {active && (
        <div
          className={`absolute z-50 w-max max-w-xs px-3 py-2 text-[11px] font-semibold text-black border dark:text-white  bg-white dark:bg-black rounded shadow-lg ${getPositionClasses()}`}
        >
          {content}
          <div
            className={`absolute w-0 h-0 border-4 border-transparent ${getArrowClasses()}`}
          />
        </div>
      )}
    </div>
  );
};

export default Tooltip;